export default function Quote() {
  return (
    <section
      data-testid="quote-section"
      className="relative bg-charcoal text-sand py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay opacity-40" />
      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <div
          aria-hidden
          className="font-serif text-rust text-7xl md:text-8xl leading-none mb-4 select-none"
        >
          "
        </div>
        <blockquote
          data-testid="quote-text"
          className="font-serif text-3xl md:text-4xl lg:text-5xl font-light leading-[1.15] tracking-tight text-sand"
        >
          Growing Country is not simply about growing food.
          <span className="block mt-5 italic text-ochre">
            It is about rebuilding local capability, strengthening community
            resilience, and restoring relationships between people, food and
            Country.
          </span>
        </blockquote>
        <div className="mt-10 text-xs uppercase tracking-[0.3em] text-sand/60">
          — The Growing Country Promise
        </div>
      </div>
    </section>
  );
}
